import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const chainResources = {
    en: {
        Confirmed: 'Confirmed',
        Pending: 'Pending',
        Declined: 'Declined',
        ChainStep: 'Step',
        ChainDate: 'Date',
        ChainTime: 'Time',
        ChainDuration: 'Duration',
        ChainPractitioner: 'Practitioner',
        ChainStatus: 'Status',
        ChainStatusUpcoming: 'Upcoming',
        ChainStatusPast: 'Past',
        ChainStatusCancelled: 'Cancelled',
        ChainBadge: 'Chain ({{count}} appointment)',
        ChainBadge_plural: 'Chain ({{count}} appointments)',
        ChainStepCountBadge: '{{count}} step',
        ChainStepCountBadge_plural: '{{count}} steps',
        SeriesBadge: 'Series ({{count}} appointment)',
        SeriesBadge_plural: 'Series ({{count}} appointments)',
        CancelChainCta: 'Cancel appointment chain',
        CancelChainDialogTitle: 'Cancel appointment chain',
        CancelChainDialogText:
            'All future appointments in this appointment chain will be cancelled. Past appointments are not affected. This action cannot be undone.',
        CancelChainConfirmCta: 'Yes, cancel',
        CancelChainRejectCta: 'No, go back',
        CancelChainError: 'Error cancelling the appointment chain. Please try again later.',
        ChainMainPractitionerHeading: 'How should we search for your appointment?',
        ChainNoPreferenceCardLabel: 'No preference',
        ChainNamedPractitionerPrompt: 'Have you had an appointment with this doctor before?',
        ChainPracticePrompt: 'Is this your first appointment at this practice?',
        ChainSeeProfile: 'See profile',
        ChainSuggestionsEyebrow: 'APPOINTMENT SUGGESTIONS FOUND',
        ChainSuggestionsTitle: 'Appointment suggestions',
        ChainSuggestionsStepsCount: '{{count}} step',
        ChainSuggestionsStepsCount_plural: '{{count}} steps',
        ChainSuggestionsAppointmentsCount: '{{count}} appointment',
        ChainSuggestionsAppointmentsCount_plural: '{{count}} appointments',
        ChainSuggestionsHelper: 'Different dates? Click on “Next suggestion”.',
        ChainOverviewTitle: 'Review your appointment details',
        ChainOverviewDetailsEyebrow: 'APPOINTMENT DETAILS',
        ChainPostBookingHeading: 'What happens after booking?',
        ChainPostBookingBullet1: 'You will receive a confirmation email with all appointments',
        ChainPostBookingBullet2: 'Before each appointment you will receive a reminder',
        ChainPostBookingBullet3: 'To change individual appointments, please call the practice',
        ChainPostBookingBullet4:
            'You can cancel the whole chain; individual appointments cannot be cancelled separately',
        ChainColIndex: '#',
        ChainColStep: 'Step',
        ChainColDate: 'Date',
        ChainColTime: 'Time',
        ChainColDuration: 'Duration',
        ChainColPractitioner: 'Practitioner',
        ChainDurationMinutes: '{{count}} min',
        ChainNextSuggestion: 'Next suggestion',
        ChainPreviousSuggestion: 'Previous suggestion',
        ChainNoAvailabilityTitle: 'No available appointments',
        ChainNoAvailabilityBody: 'We could not find any matching appointments in the desired period.',
        ChainCallUsHeading: 'Please give us a call',
        ChainCallUsBody:
            'Unfortunately we could not find any matching appointments online. Please call the practice so we can find an appointment for you together.',
        ChainNoAvailabilityBodyForPractitioner:
            'We could not find any matching appointments with {{practitioner}} in the desired period.',
        ChainChooseDifferentDoctor: 'Choose a different doctor',
        ChainAvailabilityError: 'Appointment suggestions could not be loaded.',
        ChainBookingError: 'Your appointment chain could not be booked. Please try again later.',
        ChainConfirmedHeadline: 'Your appointment chain request has been accepted!',
        ChainConfirmedText: 'You will receive a confirmation email with all your appointments.',
        ChainProcessingText: 'We are processing your appointment chain',
        ChainPartiallyFailedAlert:
            'One or more appointments in your chain could not be booked. Please call the practice so we can find new appointments for you.',
        ChainDetailsLoadError: 'Your appointment details could not be loaded. Please check My Appointments later.',
        ChainDetailsUnavailable: 'Your appointment details are not available yet. Please check My Appointments.',
        BookingTimeoutAlert: 'Your booking could not be confirmed; please make a new booking.',
        BookingUnknownStatusAlert:
            'We could not confirm the status of your appointment. Please check My Appointments or contact support.',
        ChainConfirmNewPatientNote: 'As a new patient, please arrive 15 minutes before your first appointment.',
        ChainToMyAppointments: 'To my appointments',
    },
    de: {
        Confirmed: 'Bestätigt',
        Pending: 'Ausstehend',
        Declined: 'Abgelehnt',
        ChainStep: 'Schritt',
        ChainDate: 'Datum',
        ChainTime: 'Uhrzeit',
        ChainDuration: 'Dauer',
        ChainPractitioner: 'Behandler',
        ChainStatus: 'Status',
        ChainStatusUpcoming: 'Anstehend',
        ChainStatusPast: 'Vergangen',
        ChainStatusCancelled: 'Abgesagt',
        ChainBadge: 'Kette ({{count}} Termin)',
        ChainBadge_plural: 'Kette ({{count}} Termine)',
        ChainStepCountBadge: '{{count}}-Schritt',
        ChainStepCountBadge_plural: '{{count}}-Schritte',
        SeriesBadge: 'Serie ({{count}} Termin)',
        SeriesBadge_plural: 'Serie ({{count}} Termine)',
        CancelChainCta: 'Terminkette stornieren',
        CancelChainDialogTitle: 'Terminkette stornieren',
        CancelChainDialogText:
            'Alle zukünftigen Termine in dieser Terminkette werden storniert. Vergangene Termine bleiben erhalten. Diese Aktion kann nicht rückgängig gemacht werden.',
        CancelChainConfirmCta: 'Ja, stornieren',
        CancelChainRejectCta: 'Nein, zurück',
        CancelChainError: 'Fehler beim Stornieren der Terminkette. Bitte versuchen Sie es später erneut.',
        ChainMainPractitionerHeading: 'Wie sollen wir den Termin für Sie suchen?',
        ChainNoPreferenceCardLabel: 'Wunsch-Ärzt:in',
        ChainNamedPractitionerPrompt: 'Hatten Sie schon einen Termin bei dieser Ärztin oder diesem Arzt?',
        ChainPracticePrompt: 'Ist dies Ihr erster Termin in dieser Praxis?',
        ChainSeeProfile: 'Zum Profil',
        ChainSuggestionsEyebrow: 'TERMINVORSCHLÄGE GEFUNDEN',
        ChainSuggestionsTitle: 'Terminvorschläge',
        ChainSuggestionsStepsCount: '{{count}} Schritt',
        ChainSuggestionsStepsCount_plural: '{{count}} Schritte',
        ChainSuggestionsAppointmentsCount: '{{count}} Termin',
        ChainSuggestionsAppointmentsCount_plural: '{{count}} Termine',
        ChainSuggestionsHelper: 'Andere Daten? Klicken Sie auf „Nächster Vorschlag“.',
        ChainOverviewTitle: 'Überprüfen Sie die Details Ihres Termins',
        ChainOverviewDetailsEyebrow: 'TERMINDETAILS',
        ChainPostBookingHeading: 'Was passiert nach der Buchung?',
        ChainPostBookingBullet1: 'Sie erhalten eine Bestätigungs-E-Mail mit allen Terminen',
        ChainPostBookingBullet2: 'Vor jedem Termin erhalten Sie eine Erinnerung',
        ChainPostBookingBullet3: 'Um einzelne Termine zu ändern, rufen Sie bitte in der Praxis an',
        ChainPostBookingBullet4:
            'Sie können die ganze Terminfolge stornieren, einzelne Termine können leider nicht abgesagt werden',
        ChainColIndex: '#',
        ChainColStep: 'Schritt',
        ChainColDate: 'Datum',
        ChainColTime: 'Uhrzeit',
        ChainColDuration: 'Dauer',
        ChainColPractitioner: 'Behandler:in',
        ChainDurationMinutes: '{{count}} Min.',
        ChainNextSuggestion: 'Nächster Vorschlag',
        ChainPreviousSuggestion: 'Vorheriger Vorschlag',
        ChainNoAvailabilityTitle: 'Keine verfügbaren Termine',
        ChainNoAvailabilityBody: 'Es konnten im gewünschten Zeitraum keine passenden Termine gefunden werden.',
        ChainCallUsHeading: 'Bitte rufen Sie uns an',
        ChainCallUsBody:
            'Leider konnten wir online keine passenden Termine finden. Bitte rufen Sie in der Praxis an, damit wir gemeinsam einen Termin für Sie finden können.',
        ChainNoAvailabilityBodyForPractitioner:
            'Bei {{practitioner}} konnten im gewünschten Zeitraum keine passenden Termine gefunden werden.',
        ChainChooseDifferentDoctor: 'Einen anderen Arzt wählen',
        ChainAvailabilityError: 'Verfügbarkeit konnte nicht geladen werden.',
        ChainBookingError: 'Ihre Terminkette konnte nicht gebucht werden. Bitte versuchen Sie es später erneut.',
        ChainConfirmedHeadline: 'Ihre Anfrage für die Terminkette wurde angenommen!',
        ChainConfirmedText: 'Sie erhalten eine Bestätigungs-E-Mail mit allen Ihren Terminen.',
        ChainProcessingText: 'Wir verarbeiten Ihre Terminkette',
        ChainPartiallyFailedAlert:
            'Ein oder mehrere Termine Ihrer Kette konnten nicht gebucht werden. Bitte rufen Sie in der Praxis an, damit wir neue Termine für Sie finden können.',
        ChainDetailsLoadError:
            'Ihre Termindetails konnten nicht geladen werden. Bitte prüfen Sie später Meine Termine.',
        ChainDetailsUnavailable: 'Ihre Termindetails sind noch nicht verfügbar. Bitte prüfen Sie Meine Termine.',
        BookingTimeoutAlert: 'Ihre Buchung konnte nicht bestätigt werden, bitte nehmen Sie eine neue Buchung vor.',
        BookingUnknownStatusAlert:
            'Der Status Ihres Termins konnte nicht bestätigt werden. Bitte überprüfen Sie Meine Termine oder kontaktieren Sie den Support.',
        ChainConfirmNewPatientNote:
            'Als neue Patientin oder neuer Patient kommen Sie bitte 15 Minuten vor Ihrem ersten Termin.',
        ChainToMyAppointments: 'Zu meinen Terminen',
    },
};

const categoryBrowserResources = {
    en: {
        ChooseCategoryStepTitle: 'Choose a category',
        ChooseTreatmentTypeStepTitle: 'Choose an appointment type',
        SeeAllTreatmentTypesCta: 'See all appointment types',
        AllTreatmentTypes: 'All appointment types',
        CategoryBrowserOr: 'or',
        ChangeCategoryCta: 'Change category',
        TreatmentTypesCount: '{{count}} appointment type',
        TreatmentTypesCount_plural: '{{count}} appointment types',
        ChainsCategoryName: 'Multi-step treatments',
    },
    de: {
        ChooseCategoryStepTitle: 'Kategorie wählen',
        ChooseTreatmentTypeStepTitle: 'Terminart wählen',
        SeeAllTreatmentTypesCta: 'Alle Terminarten ansehen',
        AllTreatmentTypes: 'Alle Terminarten',
        CategoryBrowserOr: 'oder',
        ChangeCategoryCta: 'Kategorie ändern',
        TreatmentTypesCount: '{{count}} Terminart',
        TreatmentTypesCount_plural: '{{count}} Terminarten',
        ChainsCategoryName: 'Mehrstufige Behandlungen',
    },
};

const resources = {
    en: {
        translation: {
            typeYourCountry: 'Type Your Country',
            Address: 'Address',
            Title: 'Eterno Health - Modern and preventive treatments',
            Description:
                'We strengthen your health! Many specialist areas with qualified doctors and therapists and numerous health offers ✓ | Eterno Health',
            Menu: 'Menu',
            Close: 'Close',
            Login: 'Login',
            Logout: 'Logout',
            OpenMenu: 'Open menu',
            CloseMenu: 'Close menu',
            Register: 'Register',
            AuthSelectionTitle: 'Do you already have an account?',
            AuthSelectionRegisterHeading: 'I am new here',
            AuthSelectionRegisterText: 'Register as a new patient and book your appointment in just a few steps.',
            AuthSelectionLoginHeading: 'I already have an account',
            AuthSelectionLoginText: 'Sign in with your Eterno account to complete your booking faster.',
            Verify: 'Verify',
            RequiredField: 'This is a required field.',
            InvalidEmail: 'Please enter a valid email address.',
            InvalidDate: 'Please enter a valid date in DD/MM/YYYY format.',
            PERSONALDATA: 'PERSONAL DATA',
            EternoAccount: 'Eterno Account',
            FirstName: 'First Name',
            LastName: 'Last Name',
            PhoneNumber: 'Phone Number',
            PROFILEIMAGE: 'PROFILE IMAGE',
            UploadImage: 'Upload a new image',
            DeleteImage: 'Delete image',
            SaveChanges: 'Save Changes',
            BILLINGPAYMENT: 'BILLING & PAYMENT',
            StreetNumber: 'Street & Number',
            ZIPCode: 'ZIP Code',
            City: 'City',
            Cancel: 'Cancel',
            Email: 'Email',
            Country: 'Country',
            CardName: 'Card holder name',
            CardNumber: 'Credit card number',
            CVV: 'CVV',
            ActivateNotification: 'Activate notifications for my Eterno appointments',
            UseAnalytics:
                'Yes, I consent to Eterno Health GmbH processing my data, including health data from my profile, for its own purposes in the sense of a ‘learning healthcare system’, for example in the area of healthcare research and product development. The data will be pseudonymised for protection.',
            DeleteAccount: 'Delete Account',
            Notifications: 'Notifications',
            WelcomeEterno: 'Welcome to Eterno',
            TryHomeDiagnostics: 'Try our Home Diagnostics and get to know your body with our tests for home.',
            FindOutHow: 'Find out how',
            YouHave: 'You have',
            AppointmentsThisWeek: 'Appointments this week',
            Details: 'Details',
            LookingForExpert: 'Looking for an expert to talk to?',
            FindAppointment: 'Find an Appointment',
            MyPractitioners: 'My Practitioners',
            Favorites: 'Favorites',
            MyClasses: 'My Classes',
            FindClass: 'Find a Class',
            BookNow: 'Book now',
            AllClasses: 'All my Classes',
            FindAnotherClass: 'Find Another Class',
            FindExpert: 'Find an Expert',
            FindAnotherDoctor: 'Find another doctor',
            FindDoctor: 'Find a doctor',
            BookAppointment: 'Book an Appointment',
            FindTest: 'Find a Home Test',
            FAQ: 'FAQ',
            YourNextAppointment: 'Future Appointments',
            YourLastTest: 'Past Appointments',
            YouHaveNoTest: 'You have not taken any test.',
            GetToKnowBetter: 'Get to know you better with our home tests.',
            FindATest: 'Find a test',
            SeeStatus: 'See status',
            SeeMyResults: 'See my results',
            SeeHealthProfile: 'See my Health Profile',
            SeeAllResults: 'See all results',
            SeeAllAppointments: 'See all appointments',
            AdvancedMeditation: 'Advanced Meditation',
            BookSpot: 'Book a spot',
            GeneralPractitioner: 'General Practitioner',
            Psychotherapist: 'Psychotherapist',
            Psychiatrist: 'Psychiatrist',
            Physiotherapists: 'Physiotherapists',
            YogaTeacher: 'Yoga Teacher',
            MeditationTrainer: 'Meditation Trainer',
            Coach: 'Coach',
            Naturopath: 'Naturopath',
            MidWives: 'Mid Wives',
            DontFindCategory: "You don't find any category that suit you? Chat with us",
            GetYouRightProfessional: "let's get you the right professional.",
            SelectingCategory: 'Start by selecting a category.',
            MindDescription:
                'Do you feel down and need someone to talk to? Here you will find psychologists, psychiatrists and coaches to talk to.',
            BodyDescription:
                'Do you have pains or are you looking for a recovery therapy? We have physiotherapists and doctors who can help you.',
            SoulDescription:
                'Are you looking for yoga or meditation courses? This is your category. We have more than 10 types of yoga to elevate your soul.',
            ComingSoon: 'Coming Soon',
            SelectCategoryHeading: 'Lorem ipsum dolor sit amet, amet ipsum',
            SelectCategorySubHeading: 'Lorum ipsum',
            SelectCategory: 'Select Category',
            LorumIpsum: 'Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. ',
            SeveralTypesOfMeditation: 'We offer several types of meditations',
            SelectOneOrMore: 'You can select more than one, or continue with all of them',
            AllOfThem: 'All of them',
            Mindfulness: 'Mindfulness',
            Spiritual: 'Spiritual',
            Focused: 'Focused',
            Movement: 'Movement',
            Transcendental: 'Transcendental',
            Progressive: 'Progressive relaxation',
            LovingKindness: 'Loving-kindness',
            Visualization: 'Visualization',
            YouHaveNoAppointment: "You don't have any appointment",
            FindAPractitioner: 'Find a practitioner',
            Lorumipsumbig:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.',
            HomeDiagnostics: 'Home Diagnostics',
            HowDoesItWork: 'How does it work?',
            HomeStep1: 'Order Plan Online in a few cliks lorem',
            HomeStep2: 'Receive and conduct the test at home',
            HomeStep3: 'View your results online lorem',
            HomeStep4: 'Medical consultation lorem ipsum*',
            DisclaimerTextHomeDiagnostics: '*The medical consultation is only available in some of our tests.',
            AlleAnzeigen: 'Alle anzeigen',
            EntdeckenBegreifen: 'Entdecken & Begreifen',
            GesundheitFitness: 'Gesundheit & Fitness',
            FruchtbarkeitGeburt: 'Fruchtbarkeit & Geburt',
            DieserTest:
                'Dieser Test untersucht Blutwerte, die essentiell für Deine Gesundheit, Fitness und Leistungsfähigkeit sind (11 Biomarker)',
            WithExpertConsultation: 'with Eterno expert consultation',
            BuyTest: 'Buy Test',
            MoreDetails: 'More details',
            include: 'inkl.',
            taxDetails: 'USt., zzgl. Versand',
            BuyHomeTest: 'Buy Home Test and Consultation',
            Congratulations: 'Congratulations, your Sleep Better test is on its way!',
            SentYouEmail: 'We have send you a confirmation email with all the details.',
            WhatHappensNext: 'What happens next?',
            CompleteMyHealthProfile: 'Complete my Health Profile',
            WhatOurCustomersSay: 'What our customers say',
            SimilarProducts: 'Similar products',
            WhatsIncludedWithMedicalConsultation: 'What’s included in the Medical Consultation?',
            DontWantMedicalConsultation: 'You don’t want the medical consultation? ',
            GetYourHomeTest: 'Get your Home Test for 39,90 €',
            DoHavePrescription: 'Do you have a prescription?',
            Yes: 'Yes',
            No: 'No',
            UploadYourPrescription: 'Upload your prescription',
            ChooseServiceManually: 'Choose service manually',
            ManuelleTherapie: 'Manuelle Therapie (MT)',
            MTmitWarmapackung: 'MT mit Warmpackung',
            MTmitElektrotherapie: 'MT mit Elektrotherapie',
            mitUltraschall: 'mit Ultraschall- Wärmetherapie',
            Krankengymnastik: 'Krankengymnastik (KG)',
            KGmitWarmapackung: 'KG mit Warmpackung',
            KGmitElektrotherapie: 'KG mit Elektrotherapie',
            ManuelleLymphdrainage30: 'Manuelle Lymphdrainage (MLD) 30 Min',
            ManuelleLymphdrainage45: 'Manuelle Lymphdrainage (MLD) 45 Min',
            ManuelleLymphdrainage60: 'Manuelle Lymphdrainage (MLD) 60 Min',
            Massagen: 'Massagen (KMT)',
            KombiBehandlungen: 'Kombi Behandlungen',
            MedicalTaping: 'Medical Taping & Kinesiotape',
            ChooseTheTherape: 'Choose the therapy that has been prescribed to you',
            HealthInsurance: 'Health insurance',
            CREDITCARD: 'CREDIT CARD',
            CardNum: 'Card number',
            StartTyping: 'Start typing',
            KnowYourHealthInsurance: 'In order to continue, we need to know your health insurance',
            ChangeHealthInsurance: 'Change health insurance',

            MorePeople: 'Yes, with more people',
            PersonalClass: 'No, I prefer a personal class',
            JustOne: 'Just one',
            MoreThanOne: 'More than one',
            NumberOfAppointments: 'Number of appointments',
            appointments: 'appointments',
            HowManyAppointmentToBook: 'How many appointment would you like to book?',
            ChangeAmount: 'Change amount',
            AppointmentDetails: 'Appointment Details',
            SelectTreatment: 'Select Treatment',
            LocationTime: 'Location & Time',
            DayOfTheWeek: 'Day of the week',
            AsSoonAsPossible: 'As soon as possible',
            TimeOfDay: 'Time of the day',
            AtAnyTime: 'At any time',
            EarlyMorning: 'Early mornings 07:00 to 09:00',
            Mornings: 'Mornings 09:00 to 12:00',
            Afternoons: 'Afternoons 12:00 to 18:00',
            LateAfternoons: 'Late afternoons 18:00 to 21:00',
            ChangeLocation: 'Change location',
            OurRecommendationForYou: 'Our recommendation for you',
            SeeProfile: 'See profile',
            YourAppointment: 'YOUR APPOINTMENT',
            ConfirmAppointment: 'Confirm Appointment',
            ShowMoreResults: 'Show more results',
            MedicalConsultation: 'Medical Consultation',
            WeNeedSomeInformation: 'We need some information in order to confrim your appointment',
            WeNeedSomeInformationText: 'We need some further information in order to confirm the appointment',
            AddCardAndContinuePayment: 'Add card and confirm payment',
            AppointmentConfirmed: 'Your appointment is confirmed',
            DoYouWantToBeNotified: 'Do you want to be notified for your appointments?',
            YourSelection: 'Your selection',
            ShowDetails: 'Show details',
            HideDetails: 'Hide details',
            ToolTipText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
            NoPastAppointment:
                'You don’t have any past appointments with this profile. But that’s OK, we can help you find the right expert for you.',
            BookClassAgain: 'Book this class again',
            DownloadInvoice: 'Download Invoice',
            AvailableAppointments: 'Available Appointments',
            ViewAllAvailableAppointments: 'View All Available Appointments',
            AvailableAppointmentPoint1: 'Lorem ipsum dolor sit amet',
            AvailableAppointmentPoint2: 'Incididunt ut labore et dolore magna',
            AvailableAppointmentPoint3: 'Exercitation ullamco laboris nisi',
            PasswordsNotMatch: 'Both passwords should be same.',
            EmailAlreadyExists: 'This email address is already in use.',
            WelcomeToHealthProfile: 'Welcome to your Health Profile',
            HealthProfileSub: 'We just need to ask you a few questions so we can help you achieve your health goals.',
            BasicDetails: 'Your individual body characteristics',
            DietDetials: 'Your Diet',
            LifestyleDetails: 'Your Lifestyle',
            GoalsDetails: 'Your Goals',
            YourHealthProfile: 'Your Health Profile',
            PreExistingConditions: 'Pre-existing conditions',
            InsuranceCompany: 'Insurance Company',
            InsuranceName: 'Insurance name',
            InsuranceNumber: 'Insurance Number',
            ValidUntil: 'Valid Until',
            InsuranceStatus: 'Insurance Status',
            Security: 'SECURITY',
            ChangePswd: 'Change Password',
            CurrentPswd: 'Current Password',
            NewPswd: 'New Password',
            CPswd: 'Confirm Password',
            NameOptional: 'Name (Optional)',
            SameLocation: 'Same as personal adress ',
            MiddleName: 'Middle Name',
            ShouldBeYourAppointment: 'Where should be your appointment?',
            ProfessionLokingFor: 'What profession are you looking for?',
            ShouldHealthInsuranceCoverCost: 'Should your health insurance cover the costs?',
            GroupAppointment: 'Are you looking for a group appointment?',
            HowManyAppointment: 'How many appointments do you need?',
            WhatKindOfHealthInsurance: 'What kind of health insurance do you have?',
            PublicInsurance: 'Public Insurance',
            PrivateInsurance: 'Private Insurance',
            SelfPayer: 'Self-payer',
            public: 'Public',
            private: 'Private',
            self_payer: 'Self Payer',
            DoYouWantFirstContactAppointmentFollowUp: 'Do you want a first contact appointment or a follow up?',
            Erstkontakt: 'First Contact',
            Folgetermin: 'Follow Up Appointment',
            WhatKindOfThreatmentLookingFor: 'What kind of treatment are you looking for?',
            DoYouHaveAnySymptoms: 'Do you have any symptoms?',
            SelectPractitioner: 'Select a practitioner',
            PrescriptionUploaded: 'Prescription uploaded',
            BookYourAppointment: 'Book your appointment',
            CreditCard: 'Credit Card',
            SEPA: 'SEPA-Lastschrift',
            ConfirmPayment: 'Confirm Payment',
            WantAnOnline: 'I want an online appointment',
            YesForMe: 'Yes, For me',
            ForMyChild: 'For my child',
            TransferSlip: 'Do you have a transfer slip?',
            MoreServices: 'Select one or more services.',
            UploadTransferSlip: 'Upload Transfer Slip',
            MobileNumber: 'Mobile Number',
            JumpToFirstSlot: 'Jump to first available slot',
            CalendarLoadFailed: 'We could not load available appointments. Please close this and try again.',
            AppointmentBookingFailed:
                'Unfortunately your appointment could not be booked. Please try again later or contact the practice.',
            NextSlotAvailable: 'Next available appointment:',
            NextSlotCta: 'Next available slot',
            NoTimeslotsAvailable:
                'Currently, there are no time slots available with this professional, please check again later.',
            ContinueBookingCta: 'To booking',
            AppointmentsTabsLabel: 'Upcoming or past appointments',
            AppointmentsThisPractice: 'This practice',
            AppointmentsAllPractices: 'All practices',
            ResetEmailLabel: 'Email address',
            ResetVerificationDescription:
                'You have just received an email with a verification code. Please enter it below.',
            NoSearchResultsTitle: 'We couldn’t find any appointment matching your input.',
            NoSearchResultsText: 'Please try another entry or go',
            NoSearchResultsBackLink: 'back',
            AllFormsCheckInPrimaryHeading: 'Heracles Therapy Center check-in',
            AllFormsPrimaryHeading: 'Enter code to access the forms',
            AllFormsSecondaryHeading: 'Enter the code generated during the patient check in',
            AllFormsCodeError: 'Wrong code, please try again',
            Continue: 'continue',
            OpenLink: 'Open Link',
            Locations: 'Locations',
            ExternalLocationMessage:
                'Please note that your appointment will take place at a location outside of the Eterno Hub.',
            prismicFallback:
                'our web app is currently not available. We are already working on a solution. If you would like to book an appointment now, call our contact center on the phone number {phone_number_placeholder}.',
            SeeMore: 'See More',
            ErrorFallbackHeading: 'Sorry, something went wrong. Please reload the page and try again.',
            ErrorFallbackParagraph:
                'In case you still experience any issues, please do not hesitate to contact us at support@eterno.health.',
            ErrorFallbackCta: 'Reload Page',
            ErrorFallbackResetApp: 'Still having issues? Reset app',
            InvitationError404: 'This link is invalid.',
            InvitationError410Cancelled:
                'Your appointment has been cancelled. If you believe this is an error, please contact us.',
            InvitationError410Passed: 'This appointment has already taken place.',
            InvitationErrorDefault: 'Something went wrong. Please try again.',
            ConsentContentUnavailable:
                'This document could not be loaded. Please go back and open the form again, or contact your practice.',
            RegistrationNoteTitle: 'Note on registration',
            RegistrationNoteText: 'To create a new account, first complete the booking process',
            UnknownForm: 'Unknown Form',
            FormsFlowCta: 'Fill out digital forms',
            CheckinForms: 'Check-in Forms',
            FormsInfo:
                'Prepare the documents so that your doctor has all important information before your appointment.',
            UploadDocumentInfo:
                'If you have documents that you would like to share with your doctor, please upload them here.',
            UploadDocument: 'Upload own medical doc.',
            SharedDocuments: 'Shared Documents',
            UploadDocumentSecurityInfo: 'We store your documents in your file, to which only your practice has access.',
            NotShared: 'Unknown',
            StaticCodeFormsTitle: 'Please fill out the following fields',
            FormsCheckInNotFoundTitle: "We couldn't find your check-in",
            FormsCheckInNotFoundIntro: 'To fill out your forms here, you need to be checked in at reception first.',
            FormsCheckInNotFoundCheckTitle: 'Please check:',
            FormsCheckInNotFoundCheck1: 'Have you already checked in at the front desk?',
            FormsCheckInNotFoundCheck2: 'Is your personal data entered correctly?',
            FormsCheckInNotFoundHelp: "Still can't continue? Please come to the front desk. We're happy to help!",
            FormsDobInvalidFormat: 'Please enter a valid date in the format DD/MM/YYYY.',
            FormsDateOfBirthLabel: 'Date of birth (DD/MM/YYYY)',
            DatePlaceholderDay: 'DD',
            DatePlaceholderMonth: 'MM',
            DatePlaceholderYear: 'YYYY',
            FormsFirstNameLabel: 'First name',
            FormsLastNameLabel: 'Last name',
            Result: 'Result',
            Results: 'Results',
            PhoneFormat: 'Please enter a valid phone number with the format +4915199999999',
            EndTriage: 'End Triage',
            StartTriage: 'Smart Triage',
            TriageEmergency:
                'Your information indicates a medical emergency. Please contact the medical on-call service immediately on 116 117 or dial 112 in acute emergencies. Alternatively, you can also go to the nearest emergency room.',
            AppointmentMatch: 'Show appointment types that match your symptoms',
            EmergencyMatch:
                'This may be a medical emergency. Call 112 immediately, or go to the nearest emergency room',
            NoMatch: 'Your symptoms do not match any of our appointment types. Please select manually',
            NewFormFlow: 'Smart anamnesis',
            StandardForms: 'Standard Forms',
            ChooseFormMethod: 'Choose how you would like to fill out your forms',
            ContinueToAppointments: 'Continue to Appointments',
            CompleteFormToContinue: 'Complete the form to continue',
            MinorPatientInfo: 'The patient is a minor',
            RegistrationLinkExpired: 'Link is expired',
            RegistrationLinkExpiredMessage:
                'The registration link you are trying to use has expired or is invalid. Please contact support for assistance.',
            RegistrationFailed: 'Something went wrong',
            RegistrationFailedMessage:
                'We could not open your registration form. Please try again later or contact support for assistance.',
            RegistrationSupportEmail: 'Mail: support@eternohealth.de',
            RegistrationSupportPhone: 'Phone: +49 40 743250638',
            FeedbackThankYou: 'Thanks for your feedback.',
            AskForFeedback: `How did you like your doctor's appointment? Share your feedback about your doctor's appointment.`,
            FeedbackCta: 'Send feedback',
            FeedbackTitle: 'All questions refer to your last visit to your doctor',
            FeedbackSection: 'Your Feedback',
            Cancelled: 'Cancelled',
            Past: 'Past',
            BookAppointmentHeading: 'Book your next doctor’s appointment',
            BookAppointmentSubheading: 'Healthcare on a new level: modern, digital and holistic.',
            ConsentConfirmCta: 'I hereby agree',
            TreatmentsAtThisLocation: 'Treatments at this location',
            ShowAllTreatments: 'Show all treatments',
            ShowFewerTreatments: 'Show fewer treatments',
            DoctorsAtThisLocation: 'Doctors at this location',
            ShowAllDoctors: 'Show all doctors',
            UpcomingAppointmentsHeading: 'Your upcoming appointments',
            NoDataProvided: 'No data provided',
            MyAccount: 'My account',
            AddressSaveFailed: 'We could not save your address. Please check it and try again.',
            AccountSettingsSaveFailed: 'We could not save your settings. Please try again.',
            ProfileSaveFailed:
                'Your account was created, but we could not save your details. Please contact us so we can complete your profile.',
            PasswordResetAfterConfirmation:
                'Your email address is confirmed. We sent you a new code so you can set a new password.',
            GoBack: 'Go back',
            TimeslotStepOne: 'Step 1',
            TimeslotStepTwo: 'Step 2',
            TimeslotPatientTypeQuestion: 'Have you been with us before?',
            TimeslotSelectionQuestion: 'Choose a timeslot',
            TimeslotMorning: 'Morning',
            TimeslotAfternoon: 'Afternoon',
            TimeslotDayCount: '{{count}} slot',
            TimeslotDayCount_plural: '{{count}} slots',
            TimeslotPreviousDays: 'Earlier days',
            TimeslotNextDays: 'Later days',
            AppointmentDetailsCta: 'View details',
            PreviousDoctorsHeading: 'Doctors you have seen',
            ...chainResources.en,
            ...categoryBrowserResources.en,
            NonBookableAppointmentMessage:
                'This type of appointment is not bookable online. Please contact your health professional directly through phone.',
            NoOnlineBookingAvailable:
                'Unfortunately, it is not possible to book your selected treatment online. Please contact us directly to arrange your preferred appointment.',
            ContactInformation: 'Contact information',
            LanguagesSpoken: 'I speak {{languages}}',
            NoLanguageInformation: 'No information',
            Online: 'Online',
        },
    },
    de: {
        translation: {
            typeYourCountry: 'Geben Sie Ihr Land ein',
            Address: 'Adresse',
            Title: 'Eterno Health - Moderne und präventive Behandlungen',
            Description:
                'Wir stärken deine Gesundheit! Viele Fachbereiche mit qualifizierten Ärzt:innen und Therapeut:innen und zahlreichen Gesundheitsangeboten ✓ | Eterno Health',
            Menu: 'Menü',
            Close: 'Schließen',
            Login: 'Anmeldung',
            Logout: 'Abmelden',
            OpenMenu: 'Menü öffnen',
            CloseMenu: 'Menü schließen',
            SeeProfile: 'Zum Profil',
            InvalidDate: 'Please enter a valid date in DD/MM/YYYY format.',
            Register: 'Registrieren',
            AuthSelectionTitle: 'Haben Sie bereits ein Konto?',
            AuthSelectionRegisterHeading: 'Ich bin neu hier',
            AuthSelectionRegisterText:
                'Registrieren Sie sich als neuer Patient und buchen Sie Ihren Termin in wenigen Schritten.',
            AuthSelectionLoginHeading: 'Ich habe bereits ein Konto',
            AuthSelectionLoginText:
                'Melden Sie sich mit Ihrem Eterno-Konto an, um Ihre Buchung schneller abzuschließen.',
            Verify: 'Verify',
            KONTAKT: 'KONTAKT',
            Impressum: 'Impressum',
            Angaben: 'Angaben Gemäß § 5 TMG',
            EternoAccount: 'Eterno-Konto',
            'Vertreten durch': 'Vertreten durch',
            Verantworltlich: 'Verantworltlich für den Inhalt nach § 55 Abs. 2 rstv',
            Telefon: 'Telefon',
            HANDELSREGISTEREINTRAG: 'HANDELSREGISTEREINTRAG',
            Registergericht: 'Registergericht',
            Registernummer: 'Registernummer',
            'Umsatzsteuer-ID': 'Umsatzsteuer-ID',
            UmsatzsteuerDetail: 'Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE 123456789',
            Haftungsausschluß: 'Haftungsausschluß (Disclaimer)',
            HaftungInhalte: 'Haftung für Inhalte',
            HaftungInhalteDetails:
                'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.',
            HaftungLinks: 'Haftung für Links',
            HaftungLinksDetails:
                'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.',
            Urheberrecht: 'Urheberrecht',
            UrheberrechtDetails:
                'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.',
            GeneralPractitioner: 'Arzt:in',
            Psychotherapist: 'Psychotherapeut',
            Psychiatrist: 'Hebamme',
            Physiotherapists: 'Physiotherapeut',
            YogaTeacher: 'Yoga Lehrer',
            MeditationTrainer: 'Meditation Trainer',
            Coach: 'Coach',
            Naturopath: 'Heilpraktiker',
            MidWives: 'Mid Wives',
            DontFindCategory: "You don't find any category that suit you? Chat with us",
            HowDoesItWork: 'Wie funktioniert es?',
            HomeStep1: 'Order Plan Online in a few cliks lorem',
            HomeStep2: 'Receive and conduct the test at home',
            HomeStep3: 'View your results online lorem',
            HomeStep4: 'Medical consultation lorem ipsum*',
            DisclaimerTextHomeDiagnostics: '*The medical consultation is only available in some of our tests.',
            AlleAnzeigen: 'Alle anzeigen',
            EntdeckenBegreifen: 'Entdecken & Begreifen',
            GesundheitFitness: 'Gesundheit & Fitness',
            FruchtbarkeitGeburt: 'Fruchtbarkeit & Geburt',
            DieserTest:
                'Dieser Test untersucht Blutwerte, die essentiell für Deine Gesundheit, Fitness und Leistungsfähigkeit sind (11 Biomarker)',
            WithExpertConsultation: 'with Eterno expert consultation',
            BuyTest: 'Buy Test',
            MoreDetails: 'More details',
            include: 'inkl.',
            taxDetails: 'USt., zzgl. Versand',
            BuyHomeTest: 'Buy Home Test and Consultation',
            Congratulations: 'Congratulations, your Sleep Better test is on its way!',
            WhatHappensNext: 'What happens next?',
            CompleteMyHealthProfile: 'Complete my Health Profile',
            HomeStepTitle1: 'Order Plan online',
            HomeStepTitle2: 'Take test at home',
            HomeStepTitle3: 'Comprehend the results',
            HomeStepText1: 'You will get your test per mail in the next 3-5 business days.',
            HomeStepText2: 'Follow the instructions in the box and send the test back to us.',
            HomeStepText3: 'You will get understandable results and personal recommendations.',
            WhatOurCustomersSay: 'Was unsere Kunden sagen',
            SimilarProducts: 'Similar products',
            WhatsIncludedWithMedicalConsultation: 'What’s included in the Medical Consultation?',
            DontWantMedicalConsultation: 'You don’t want the medical consultation? ',
            GetYourHomeTest: 'Get your Home Test for 39,90 €',
            DoHavePrescription: 'Do you have a prescription?',
            Yes: 'Ja',
            No: 'Nein',
            UploadYourPrescription: 'Upload your prescription',
            ChooseServiceManually: 'Choose service manually',
            ManuelleTherapie: 'Manuelle Therapie (MT)',
            MTmitWarmapackung: 'MT mit Warmpackung',
            MTmitElektrotherapie: 'MT mit Elektrotherapie',
            mitUltraschall: 'mit Ultraschall- Wärmetherapie',
            Krankengymnastik: 'Krankengymnastik (KG)',
            KGmitWarmapackung: 'KG mit Warmpackung',
            KGmitElektrotherapie: 'KG mit Elektrotherapie',
            ManuelleLymphdrainage30: 'Manuelle Lymphdrainage (MLD) 30 Min',
            ManuelleLymphdrainage45: 'Manuelle Lymphdrainage (MLD) 45 Min',
            ManuelleLymphdrainage60: 'Manuelle Lymphdrainage (MLD) 60 Min',
            Massagen: 'Massagen (KMT)',
            KombiBehandlungen: 'Kombi Behandlungen',
            MedicalTaping: 'Medical Taping & Kinesiotape',
            ChooseTheTherape: 'Choose the therapy that has been prescribed to you',
            WhatKindOfHealthInsurance: 'What kind of health insurance do you have?',
            PublicInsurance: 'Public insurance',
            PrivateInsurance: 'Private insurance',
            SelfPayer: 'Selbstzahler:in',
            public: 'Gesetzlich',
            private: 'Privat',
            self_payer: 'Selbstzahler',
            HealthInsurance: 'Krankenversicherung',
            CardNum: 'Card number',
            StartTyping: 'Start typing',
            ShowDetails: 'Details anzeigen',
            ToolTipText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
            NoPastAppointment:
                'You don’t have any past appointments with this profile. But that’s OK, we can help you find the right expert for you.',
            BookClassAgain: 'Book this class again',
            DownloadInvoice: 'Download Invoice',
            AvailableAppointments: 'Available Appointments',
            ViewAllAvailableAppointments: 'View All Available Appointments',
            AvailableAppointmentPoint1: 'Lorem ipsum dolor sit amet',
            AvailableAppointmentPoint2: 'Incididunt ut labore et dolore magna',
            AvailableAppointmentPoint3: 'Exercitation ullamco laboris nisi',
            PasswordsNotMatch: 'Both passwords should be same.',
            EmailAlreadyExists: 'This email address is already in use.',
            WelcomeToHealthProfile: 'Welcome to your Health Profile',
            HealthProfileSub: 'We just need to ask you a few questions so we can help you achieve your health goals.',
            BasicDetails: 'Deine Individuelle Körpereigenschaften',
            DietDetials: 'Deine Ernährung',
            LifestyleDetails: 'Dein Lebensstil',
            GoalsDetails: 'Deine Ziele',
            YourHealthProfile: 'Your Health Profile',
            PreExistingConditions: 'Vorerkrankungen',
            MobileNumber: 'Handynummer',
            InsuranceName: 'Krankenversicherung',
            InsuranceNumber: 'Versichertennummer',
            JumpToFirstSlot: 'Spring zum ersten verfügbaren Zeitfenster',
            CalendarLoadFailed:
                'Die verfügbaren Termine konnten nicht geladen werden. Bitte schließen Sie das Fenster und versuchen Sie es erneut.',
            AppointmentBookingFailed:
                'Ihr Termin konnte leider nicht gebucht werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie die Praxis.',
            NextSlotAvailable: 'Nächster freier Termin:',
            NextSlotCta: 'Nächstes Zeitfenster',
            NoTimeslotsAvailable:
                'Zurzeit sind keine Zeitfenster für diese Behandler:in verfügbar. Bitte schau später noch einmal nach.',
            ContinueBookingCta: 'Zur Buchung',
            AppointmentsTabsLabel: 'Anstehende oder vergangene Termine',
            AppointmentsThisPractice: 'Diese Praxis',
            AppointmentsAllPractices: 'Alle Praxen',
            ResetEmailLabel: 'E-Mail-Adresse',
            ResetVerificationDescription:
                'Sie haben eben eine E-Mail mit einem Verifizierungscode erhalten. Bitte tippen Sie diesen ein.',
            NoSearchResultsTitle: 'Wir konnten keinen Termin finden, der Ihrer Eingabe entspricht.',
            NoSearchResultsText: 'Bitte versuchen Sie es mit einer anderen Eingabe oder gehen Sie',
            NoSearchResultsBackLink: 'zurück',
            AllFormsCheckInPrimaryHeading: 'Herakles Therapiezentrum Check-in',
            AllFormsPrimaryHeading: 'Geben Sie den Code ein, um auf die Formulare zuzugreifen',
            AllFormsSecondaryHeading: 'Geben Sie den beim Patienten-Check-in generierten Code ein',
            AllFormsCodeError: 'Falscher Code, bitte versuchen Sie es erneut',
            Continue: 'Weiter',
            OpenLink: 'Link Öffnen',
            Locations: 'Standorte',
            ExternalLocationMessage:
                'Bitte beachten Sie, dass Ihr Termin an einem Ort außerhalb des Eterno Hub stattfinden wird.',
            prismicFallback:
                'die Seite ist aktuell leider nicht erreichbar. Wir arbeiten bereits an einer Lösung. Wenn Sie jetzt einen Termin buchen möchten, rufen Sie unser Contact Center unter der Telefonnummer {phone_number_placeholder} an.',
            SeeMore: 'Mehr',
            ErrorFallbackHeading:
                'Sorry, da ist etwas schief gelaufen. Bitte laden Sie die Seite neu und versuchen Sie es noch einmal.',
            ErrorFallbackParagraph:
                'Falls Sie immer noch Probleme haben, zögern Sie bitte nicht, uns unter support@eterno.health zu kontaktieren.',
            ErrorFallbackCta: 'Seite neu laden',
            ErrorFallbackResetApp: 'Probleme bestehen? App zurücksetzen',
            InvitationError404: 'Dieser Link ist ungültig.',
            InvitationError410Cancelled:
                'Ihr Termin wurde storniert. Wenn Sie glauben, dass es sich um einen Fehler handelt, kontaktieren Sie uns bitte.',
            InvitationError410Passed: 'Dieser Termin hat bereits stattgefunden.',
            InvitationErrorDefault: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
            ConsentContentUnavailable:
                'Dieses Dokument konnte nicht geladen werden. Bitte gehen Sie zurück und öffnen Sie das Formular erneut oder wenden Sie sich an Ihre Praxis.',
            RegistrationNoteTitle: 'Hinweis zur Registrierung',
            RegistrationNoteText: 'Um ein neues Konto anzulegen, schließen Sie zunächst den Buchungsprozess ab',
            UnknownForm: 'Unbekanntes Formular',
            FormsFlowCta: 'Digitale Formulare ausfüllen',
            UploadDocumentInfo:
                'Wenn Sie Dokumente haben, die Sie mit Ihrer Ärztin oder Ihrem Arzt teilen möchten, laden Sie diese hier hoch',
            UploadDocument: 'Eigenes Dokument hochladen',
            SharedDocuments: 'Geteilte Dokumente',
            UploadDocumentSecurityInfo:
                'Ihre Dokumente werden in Ihrer Akte abgelegt, auf die ausschließlich Ihre Praxis Zugriff hat.',
            CheckinForms: 'Check-in-Formulare',
            FormsInfo:
                'Bereiten Sie die Dokumente vor, damit Ihre Ärztin oder Ihr Arzt bereits vor dem Termin alle wichtigen Informationen vorliegen hat.',
            NotShared: 'Unbekannt',
            StaticCodeFormsTitle: 'Bitte füllen Sie die folgenden Felder aus',
            FormsCheckInNotFoundTitle: 'Wir konnten Ihren Check-in nicht finden',
            FormsCheckInNotFoundIntro:
                'Um Ihre Formulare hier auszufüllen, müssen Sie sich zunächst an der Rezeption anmelden.',
            FormsCheckInNotFoundCheckTitle: 'Bitte überprüfen Sie Folgendes:',
            FormsCheckInNotFoundCheck1: 'Haben Sie sich bereits an der Rezeption angemeldet?',
            FormsCheckInNotFoundCheck2: 'Sind Ihre persönlichen Daten korrekt eingegeben?',
            FormsCheckInNotFoundHelp:
                'Können Sie immer noch nicht fortfahren? Bitte kommen Sie zur Rezeption. Wir helfen Ihnen gerne weiter!',
            FormsDobInvalidFormat: 'Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein.',
            FormsDateOfBirthLabel: 'Geburtsdatum (TT.MM.JJJJ)',
            DatePlaceholderDay: 'TT',
            DatePlaceholderMonth: 'MM',
            DatePlaceholderYear: 'JJJJ',
            FormsFirstNameLabel: 'Vorname',
            FormsLastNameLabel: 'Nachname',
            Result: 'Ergebnis',
            Results: 'Ergebnisse',
            PhoneFormat: 'Bitte geben Sie eine gültige Telefonnummer mit dem Format +4915199999999 ein',
            EndTriage: 'Triage Beenden',
            StartTriage: 'Smart Triage',
            AppointmentMatch: 'Terminarten, die zu Ihren Symptomen passen, anzeigen',
            EmergencyMatch:
                'Das könnte ein medizinischer Notfall sein. Wählen Sie umgehend die 112 oder gehen Sie zur nächsten Notaufnahme',
            NoMatch:
                'Deine Symptome passen zu keiner unserer Terminarten. Bitte wählen Sie manuell eine Terminart aus.',
            NewFormFlow: 'Smarte Anamnese',
            StandardForms: 'Standard-Formulare',
            ChooseFormMethod: 'Wählen Sie aus, wie Sie Ihre Formulare ausfüllen möchten',
            ContinueToAppointments: 'Weiter zu Terminen',
            CompleteFormToContinue: 'Füllen Sie das Formular aus, um fortzufahren',
            MinorPatientInfo: 'Minderjährige/r Patient*in',
            RequiredField: 'Dies ist ein Pflichtfeld.',
            RegistrationLinkExpired: 'Link ist abgelaufen',
            RegistrationLinkExpiredMessage:
                'Der Registrierungslink, den Sie verwenden möchten, ist abgelaufen oder ungültig. Bitte kontaktieren Sie den Support für Unterstützung.',
            RegistrationFailed: 'Etwas ist schiefgelaufen',
            RegistrationFailedMessage:
                'Ihr Registrierungsformular konnte nicht geöffnet werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support für Unterstützung.',
            RegistrationSupportEmail: 'E-Mail: support@eternohealth.de',
            RegistrationSupportPhone: 'Telefon: +49 40 743250638',
            FeedbackThankYou: 'Vielen Dank, dass Sie Ihre Erfahrungen mit uns teilen.',
            AskForFeedback: 'Wie haben Sie Ihren Arztbesuch erlebt? Teilen Sie Ihre Erfahrungen mit uns.',
            FeedbackCta: 'Erfahrungen senden',
            FeedbackTitle: 'Alle Fragen beziehen sich auf den letzten Besuch bei Ihrem Arzt/ Ihrer Ärztin',
            FeedbackSection: 'Ihre Erfahrung',
            Cancelled: 'Abgesagt',
            Past: 'Vergangen',
            BookAppointmentHeading: 'Buchen Sie Ihren nächsten Arzttermin',
            BookAppointmentSubheading:
                'Gesundheitsversorgung auf einem neuen Niveau: zeitgemäß, digital und ganzheitlich.',
            ConsentConfirmCta: 'Hiermit stimme ich zu',
            TreatmentsAtThisLocation: 'Behandlungen an diesem Standort',
            ShowAllTreatments: 'Alle Behandlungen anzeigen',
            ShowFewerTreatments: 'Weniger Behandlungen anzeigen',
            DoctorsAtThisLocation: 'Ärzt:innen an diesem Standort',
            ShowAllDoctors: 'Alle Ärzt:innen anzeigen',
            UpcomingAppointmentsHeading: 'Ihre nächsten Termine',
            NoDataProvided: 'Keine Angabe',
            MyAccount: 'Mein Konto',
            UploadImage: 'Bild hochladen',
            AddressSaveFailed:
                'Ihre Adresse konnte nicht gespeichert werden. Bitte prüfen Sie sie und versuchen Sie es erneut.',
            AccountSettingsSaveFailed:
                'Ihre Einstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
            ProfileSaveFailed:
                'Ihr Konto wurde erstellt, aber Ihre Daten konnten nicht gespeichert werden. Bitte kontaktieren Sie uns, damit wir Ihr Profil vervollständigen können.',
            PasswordResetAfterConfirmation:
                'Ihre E-Mail-Adresse ist bestätigt. Wir haben Ihnen einen neuen Code gesendet, damit Sie ein neues Passwort festlegen können.',
            GoBack: 'Zurück',
            TimeslotStepOne: 'Schritt 1',
            TimeslotStepTwo: 'Schritt 2',
            TimeslotPatientTypeQuestion: 'Waren Sie schon einmal bei uns?',
            TimeslotSelectionQuestion: 'Wählen Sie ein Zeitfenster aus',
            TimeslotMorning: 'Vormittag',
            TimeslotAfternoon: 'Nachmittag',
            TimeslotDayCount: '{{count}} Termin',
            TimeslotDayCount_plural: '{{count}} Termine',
            TimeslotPreviousDays: 'Frühere Tage',
            TimeslotNextDays: 'Spätere Tage',
            AppointmentDetailsCta: 'Details ansehen',
            PreviousDoctorsHeading: 'Ihre bisherigen Ärzt:innen',
            SeeAllAppointments: 'Alle Termine anzeigen',
            ...chainResources.de,
            ...categoryBrowserResources.de,
            NonBookableAppointmentMessage:
                'Diese Art von Termin kann nicht online gebucht werden. Bitte kontaktieren Sie Ihr Praxisteam direkt telefonisch.',
            NoOnlineBookingAvailable:
                'Für Ihre gewählte Behandlung ist eine Online-Buchung leider nicht möglich. Bitte kontaktieren Sie uns direkt, um den gewünschten Termin zu vereinbaren.',
            ContactInformation: 'Kontaktdaten',
            LanguagesSpoken: 'Ich spreche {{languages}}',
            NoLanguageInformation: 'Keine Angabe',
            Online: 'Online',
            UseAnalytics:
                'Ja, ich willige ein, dass die Eterno Health GmbH meine Daten, einschließlich Gesundheitsdaten aus meinem Profil, im Sinne eines „lernenden Gesundheitswesens“ auch für eigene Zwecke verarbeitet, etwa im Bereich der Versorgungsforschung und Produktentwicklung. Die Daten werden dabei zum Schutz pseudonymisiert.',
        },
    },
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: resources,
        lng: localStorage.getItem('languageGlobal'), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        fallbackLng: 'de',
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
